import type React from 'react';

import { Typography } from '@material-ui/core';

interface IProps {
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  children?: React.ReactNode;
  className?: string;
}

export const Placeholder = ({
  Icon,
  text,
  className = '',
  children,
}: IProps) => {
  return (
    <div
      className={`flex flex-col items-center justify-center space-y-2 ${className}`}
    >
      {Icon && <Icon className='h-16 w-16' />}
      <Typography>{text}</Typography>
      {children}
    </div>
  );
};

export default Placeholder;
